import moment from "moment";
import React, { Component } from "react";
import "react-datepicker/dist/react-datepicker.css";
import { Col, Row } from "react-bootstrap";
import Api from "../../../../tools/api/api";
import IFilterRequest from "../../../../tools/api/api-interfaces/projects/logs/IFilterRequest";
import AuthHelper from "../../../../tools/auth/AuthHelper";
import ValidationErrors from "../../../../tools/validation-helper/ValidationErrors";
import Validations from "../../../../tools/validation-helper/Validations";
import withEngineCompartmentAuthorize from "../../../common/authorize/withEngineCompartmentAuthorize";
import ContainerPageSize from "../../../common/layout-components/container-page-size/ContainerPageSize";
import { LoadingBarHeight } from "../../../common/layout-components/loading-bar/ILoadingBarProps";
import LoadingBar from "../../../common/layout-components/loading-bar/LoadingBar";
import PaginationComponent from "../../../common/layout-components/pagination/PaginationComponent";
import ProjectSubMenu from "../../../common/layout-components/project-sub-menu/ProjectSubMenu";
import { VerticalSpaceSize } from "../../../common/layout-components/vertical-space/IVerticalSpaceProps";
import VerticalSpace from "../../../common/layout-components/vertical-space/VerticalSpace";
import LogsComponent from "../../../common/telemetry-components/logs-component/LogsComponent";
import ValidationSummary from "../../../common/validation-summary/ValidationSummary";
import ILogsPageProps from "./ILogsPageProps";
import ILogsPageState from "./ILogsPageState";

class LogsPage extends Component<ILogsPageProps, ILogsPageState> {
  constructor(props: ILogsPageProps) {
    super(props);

    this.state = {
      projectId: 0,
      projectFullName: "",
      knownLoggers: [],
      knownLevels: [],
      logs: [],
      fromTimestamp: "",
      toTimestamp: "",
      from: moment().toDate(),
      to: moment().toDate(),
      pageIndex: 0,
      totalPages: 0,
      isLoading: true,
      validationErrors: null
    };

    this.onSearchClick = this.onSearchClick.bind(this);
    this.handlePageClick = this.handlePageClick.bind(this);
  }


  render() {
    return (
      <>
        {
          this.state.isLoading ? <LoadingBar size={LoadingBarHeight.normal}/> :
            <>
              <ProjectSubMenu projectId={this.state.projectId ?? 0}/>
              <VerticalSpace size={VerticalSpaceSize.small}/>

              <ContainerPageSize>

                <VerticalSpace size={VerticalSpaceSize.small}/>
                <h1 className="text-break">{this.state.projectFullName}</h1>
                <VerticalSpace size={VerticalSpaceSize.small}/>

                <Row>
                  <Col md={{span: 6, offset: 3}}>
                    <ValidationSummary errors={this.state.validationErrors ?? {}} excludeKeys={["From", "To",]}/>
                  </Col>
                </Row>

                <LogsComponent from={this.state.from}
                               to={this.state.to}
                               knownLevels={this.state.knownLevels}
                               knownLoggers={this.state.knownLoggers}
                               logs={this.state.logs}
                               validationErrors={this.state.validationErrors ?? {}}
                               onFromDateClick={(date: Date) => this.setFromDateClick(date)}
                               onToDateClick={(date: Date) => this.setToDateClick(date)}
                               onLevelChangeClick={(index: number) => this.onLevelChangeClick(index)}
                               onLoggerChangeClick={(index: number) => this.onLoggerChangeClick(index)}
                               onSearchClick={this.onSearchClick}
                />

                <PaginationComponent pageCount={this.state.totalPages}
                                     currentPage={this.state.pageIndex}
                                     onPageChange={(page) => this.handlePageClick(page)}
                />

              </ContainerPageSize>
            </>
        }
      </>
    );
  }

  async componentDidMount() {
    let projectId: number = this.props.projectId ? +this.props.projectId : 0;
    this.setState({projectId: projectId});

    let token = AuthHelper.getAccessToken() ?? '';

    try {
      let response = await Api.getProjectLogs(token, projectId);

      this.setState({
        projectId: projectId,
        projectFullName: response.projectFullName,
        knownLoggers: response.knownLoggers,
        knownLevels: response.knownLevels,
        logs: response.logs,
        fromTimestamp: response.fromTimestamp,
        toTimestamp: response.toTimestamp,
        from: moment(response.fromTimestamp).toDate(),
        to: moment(response.toTimestamp).toDate(),
        pageIndex: response.pageIndex,
        totalPages: response.totalPages,
        isLoading: false
      });
    } catch (err) {
      this.setValidationErrors(Validations.buildApiCommunicationErrors('Can\'t get project logs', err));
    }
  }

  private setFromDateClick(date: Date) {
    let state = {...this.state};
    state.from = date;
    state.validationErrors = {};
    this.setState(state);
  }

  private setToDateClick(date: Date) {
    let state = {...this.state};
    state.to = date;
    state.validationErrors = {};
    this.setState(state);
  }

  private onLevelChangeClick(index: number) {
    let knownLevels = [...this.state.knownLevels];
    knownLevels[index] = {...knownLevels[index], isSelected: !knownLevels[index].isSelected};
    this.setState({knownLevels: knownLevels});
  }

  private onLoggerChangeClick(index: number) {
    let knownLoggers = [...this.state.knownLoggers];
    knownLoggers[index] = {...knownLoggers[index], isSelected: !knownLoggers[index].isSelected};
    this.setState({knownLoggers: knownLoggers});
  }

  private async onSearchClick(pageIndex?: number) {
    if (this.state.pageIndex !== pageIndex) {
      this.setState({isLoading: true});

      let token = AuthHelper.getAccessToken() ?? '';

      if (!this.state.from || !Date.parse(this.state.from.toISOString() ?? "")) {
        this.addValidationError('From', 'Please select from date');
        return;
      }

      if (!this.state.to || !Date.parse(this.state.to.toISOString() ?? "")) {
        this.addValidationError('To', 'Please select to date');
        return;
      }

      let levels: string[] = [];
      let loggers: string[] = [];

      this.state.knownLevels.forEach(x => {
        if (x.isSelected) {
          levels.push(x.value);
        }
      });

      this.state.knownLoggers.forEach(x => {
        if (x.isSelected) {
          loggers.push(x.value);
        }
      });

      let request: IFilterRequest = {
        from: moment(this.state.from).format("YYYY-MM-DDTHH:mm:ss"),
        to: moment(this.state.to).format("YYYY-MM-DDTHH:mm:ss"),
        levels: levels,
        loggers: loggers,
        pageIndex: pageIndex ?? 0
      };

      let projectId: number = this.state.projectId;

      try {
        let response = await Api.filterProjectLogs(token, request, projectId);

        this.setState({
          knownLoggers: response.knownLoggers,
          knownLevels: response.knownLevels,
          logs: response.logs,
          pageIndex: response.pageIndex,
          totalPages: response.totalPages,
          isLoading: false
        });
      } catch (err) {
        this.setValidationErrors(Validations.buildApiCommunicationErrors('Can\'t filter project logs', err));
      }
    }
  }

  private addValidationError(key: string, message: string) {
    let state = {...this.state};
    state.validationErrors = {};
    Validations.addError(state.validationErrors, key, message);
    this.setState(state);
  }

  private setValidationErrors(validationErrors: ValidationErrors) {
    let state = {...this.state};
    state.validationErrors = validationErrors;
    state.isLoading = false;
    this.setState(state);
  }

  private async handlePageClick(pageIndex: number) {
    this.onSearchClick(pageIndex);
  }
}

export default withEngineCompartmentAuthorize(LogsPage);